module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_yamori02-ee20ab3f3111ff87ef43cbc33638a255.jpg";